<div class="mb-3">
  <button
    #prevButton
    [attr.title]="'global.productsFooter.sliderCards.sliderControlPrev' | translate"
    class="btn btn-primary--dark-blue btn-icon btn-md"
    [attr.data-swiper-btn]="'prev'"
  >
    <i aria-hidden="true" class="fa fa-chevron-left"></i>
  </button>
  <button
    #nextButton
    [attr.title]="'global.productsFooter.sliderCards.sliderControlNext' | translate"
    class="btn btn-primary--dark-blue btn-icon btn-md ml-2"
    [attr.data-swiper-btn]="'next'"
  >
    <i aria-hidden="true" class="fa fa-chevron-right"></i>
  </button>
</div>
<div class="swiper-focus-outline-fix">
  <swiper-container #swiper init="false" class="swiper swiper-container s-wrapper">
    <ng-content />
  </swiper-container>
</div>
